import AuditIndex from './AuditIndex';

export default AuditIndex;
